app.factory("Administrators", ["$http",
    function ($http) {
        var Admins = {};

        Admins.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;
            return $http.get("/admin/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    faculty: params.faculty
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Admins.edit = function (student) {
            return $http.post("/admin/update", student)
        };

        Admins.add = function (student) {
            return $http.post("/admin/add", student)
        };

        return Admins;
    }
]);